
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[...param]",
      function () {
        return require("private-next-pages/coaches/[...param]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[...param]"])
      });
    }
  